
export function genericReducer(state, action) {
    switch (action.type) {
        case 'SET_DATA':
            return {
                ...state,
                data: action.payload.data,
                totalRows: action.payload.totalRows,
            };
        case 'ADD_ITEM':
            return {
                ...state,
                data: [action.payload, ...state.data],
                totalRows: state.totalRows + 1,
            };
        case 'DELETE_ITEM':
            return {
                ...state,
                data: state.data.filter((item) => item.id !== action.payload),
                totalRows: state.totalRows > 0 ? state.totalRows - 1 : 0,
            };
        case 'UPDATE_ITEM':
            return {
                ...state,
                data: state.data.map((item) =>
                    item.id === action.payload.id ? action.payload : item
                ),
            };
        default:
            return state;
    }
}
